function useAssetHost() {
  const assetHost = process.env.NEXT_ASSET_PREFIX || '/'

  if (process.env.NODE_ENV === 'production') return assetHost

  return '/'
}

export default useAssetHost
